import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from "@angular/core";
//import { ExternalAddressExtended } from "../interfaces/external-address-extended";
import { TelephoneNumberAddressWithCallerId } from "../externalPhoneNumberPage/external-phone-number-page.component";
import { E2eLocators } from "@onsip/e2e/configs/locators";

@Component({
  selector: "onsip-external-phone-number-shelf-view",
  templateUrl: "./external-phone-number-shelf-view.component.html",
  styleUrls: ["../external-phone-number-shelves.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class ExternalPhoneNumberViewComponent {
  @Input() externalPhoneNum!: TelephoneNumberAddressWithCallerId;
  @Output() startEditing = new EventEmitter<void>();
  E2eLocators = E2eLocators;
}
